import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import { menu as styles } from "./styles";
class DropMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: undefined,
    };
  }

  handleOpen = (e) => {
    this.setState({ anchorEl: e.currentTarget });
  };

  handleClose = (e) => {
    this.setState({ anchorEl: false });
  };
  handleLink = (type = "") => () => {
    const { adminService = {} } = this.props;
    this.handleClose();
    this.props.history.push({
      pathname: `/service-admin/${type}`,
      search: this.props.location.search,
      state: {
        adminService: adminService,
      },
    });
  };

  render() {
    const { t, classes } = this.props;
    const { anchorEl } = this.state;
    return (
      <div>
        <Button
          aria-controls="admin_service_menu"
          aria-haspopup="true"
          onClick={this.handleOpen}
        >
          {t("menu_menu")}{" "}
          <ArrowDropDownIcon className={classes.dropdownIcon} />
        </Button>
        <Menu
          id="admin_service_menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          classes={{
            paper: classes.menu,
          }}
        >
          <MenuItem onClick={this.handleLink("detail")}>
            {t("sidebar_detail")}
          </MenuItem>
          <MenuItem onClick={this.handleLink("branch")}>
            {t("sidebar_branch")}
          </MenuItem>
          <MenuItem onClick={this.handleLink("album")}>
            {t("sidebar_album")}
          </MenuItem>
          <MenuItem onClick={this.handleLink("storage")}>
            {t("sidebar_storage")}
          </MenuItem>
          <MenuItem onClick={this.handleLink("menu")}>
            {t("sidebar_menu")}
          </MenuItem>
          <MenuItem onClick={this.handleLink("module")}>
            {t("sidebar_module")}
          </MenuItem>
          <MenuItem onClick={this.handleLink("owner")}>
            {t("sidebar_service_account")}
          </MenuItem>
          <MenuItem onClick={this.handleLink("payment")}>
            {t("sidebar_service_payment")}
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

DropMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  adminService: state.service.adminService,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(DropMenu)));
